import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IUserContactGroup } from '../../store/models/user-group.model';
import {
  DIALOG_COMPONENT,
  DialogComponent,
} from '../../shared/ui/dialog/dialog.component';

export const PURGE_MODE_LINES = [
  'I understand that contacts at email position 1 with no reply action and no message will be soft deleted.',
  'Other contacts will be kept. The contact group will be soft deleted only if no contacts remain.',
  'If no contacts qualify, the operation will not run unless the group is already empty.',
];

@Component({
  selector: 'app-delete-contact-group',
  templateUrl: './delete-contact-group.component.html',
  styleUrls: ['./delete-contact-group.component.scss'],
})
export class DeleteContactGroupComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  contactGroup: IUserContactGroup;
  inputForm: FormGroup;
  componentReady = true;

  readonly purgeModeLines = PURGE_MODE_LINES;

  private readonly destroy$ = new Subject<void>();

  constructor(
    @Inject(DIALOG_COMPONENT) private readonly dialog: DialogComponent,
  ) {}

  ngOnInit(): void {
    this.inputForm.addControl(
      'purge_mode',
      new FormControl(false, [Validators.requiredTrue]),
    );
  }

  ngAfterViewInit(): void {
    const control = this.inputForm.get('purge_mode');
    const syncYes = () =>
      this.dialog.setButtonDisabled('Yes', !control.value);

    setTimeout(() => syncYes());
    control.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => syncYes());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
